import { Pipe, PipeTransform } from '@angular/core';
import { Therapies } from 'src/app/shared/models/therapy';

@Pipe({
  name: 'therapyColor',
})
export class TherapyColorPipe implements PipeTransform {
  transform(value: any) {
    const retVal = Therapies.therapyItems.find(therapyItem => therapyItem.id === value);
    if (retVal) {
      return retVal.color;
    }
  }
}
